__webpack_require__.p = "/bio-chart-web/";